import React from "react";
import TextInputComp from "../../../components/inputs/TextInputComp";
import Button from "../../../components/buttons/Button";
import { BookOpenIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { TExam } from "./ExamsConfigs";

type TProps = {
  exams: TExam[];
  selExam: TExam | null;
  setSelExam: (exam: TExam) => void;
  examName: string;
  setExamName: (name: string) => void;
  onAddExam: () => void;
  onEditExam: (exam: TExam) => void;
  onDeleteExam: (id: string, e: React.MouseEvent) => void;
  isAddingExam: boolean;
};

const ExamsSidebar = ({
  exams,
  selExam,
  setSelExam,
  examName,
  setExamName,
  onAddExam,
  onEditExam,
  onDeleteExam,
  isAddingExam,
}: TProps) => {
  return (
    <div className="w-[300px] flex flex-col bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      <div className="p-4 border-b border-gray-50 bg-gray-50/30">
        <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <BookOpenIcon className="w-5 h-5 text-primary" />
          Exams
        </h3>
      </div>

      <div className="flex-1 overflow-y-auto p-3 space-y-1">
        {exams && exams.length > 0 ? (
          exams.map((exam) => (
            <div
              key={exam?._id}
              onClick={() => setSelExam(exam)}
              className={`group px-4 py-3 flex items-center justify-between rounded-xl cursor-pointer transition-all duration-200 ${exam?._id === selExam?._id
                  ? "bg-primary text-white shadow-md shadow-primary/20"
                  : "hover:bg-primary/5 text-gray-600 hover:text-primary"
                }`}
            >
              <span className="font-medium truncate flex-1">{exam.name}</span>

              <div
                className={`flex items-center gap-1 transition-opacity ${exam?._id === selExam?._id
                    ? "opacity-100"
                    : "opacity-0 group-hover:opacity-100"
                  }`}
              >
                <button
                  type="button"
                  className={`p-1.5 rounded-lg transition-colors ${
                    exam?._id === selExam?._id
                      ? "hover:bg-white/20 text-white"
                      : "hover:bg-primary/10 text-gray-400 hover:text-primary"
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditExam(exam);
                  }}
                  title="Edit Exam"
                >
                  <PencilIcon className="w-4 h-4" />
                </button>

                <button
                  type="button"
                  className={`p-1.5 rounded-lg transition-colors ${
                    exam?._id === selExam?._id
                      ? "hover:bg-white/20 text-white"
                      : "hover:bg-red-50 text-gray-400 hover:text-red-500"
                  }`}
                  onClick={(e) => onDeleteExam(exam._id, e)}
                  title="Delete Exam"
                >
                  <TrashIcon className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="py-10 text-center">
            <p className="text-sm text-gray-400">No exams found</p>
          </div>
        )}
      </div>

      <div className="p-4 border-t border-gray-100 bg-gray-50/30 space-y-3">
        <TextInputComp
          placeholder="New Exam Name..."
          onChange={(e) => setExamName(e.target.value)}
          value={examName}
          containerclassName="!mt-0"
        />

        <Button
          title="Add Exam"
          onClick={onAddExam}
          loading={isAddingExam}
          className="w-full !py-2"
        />
      </div>
    </div>
  );
};

export default ExamsSidebar;
